import {useCallback, useState} from 'react'
import {ContactStatus} from '../../services/cellcast.v2.types'
import {SelectOption} from '../types'
import {Tag} from '../../services/cellcast.type'

export function useContactFilter() {
  const [tagOptions, setTagOptions] = useState<SelectOption<String>[]>([])
  const [statusOptions] = useState<SelectOption<ContactStatus>[]>([
    {
      value: ContactStatus.subscribe,
      label: ContactStatus.subscribe.toUpperCase(),
    },
    {
      value: ContactStatus.unsubscribe,
      label: ContactStatus.unsubscribe.toUpperCase(),
    },
  ])

  const findStatus = useCallback(
    (status: ContactStatus | string) => {
      return statusOptions.find((el) => el.value === status)
    },
    [statusOptions]
  )

  const setTagOptionFromArr = (tags: Tag[]) => {
    setTagOptions(
      tags.map((el) => ({
        label: el.name.toUpperCase(),
        value: el._id,
      }))
    )
  }

  const findTags = useCallback(
    (ids: string[], include : boolean = true) => {
      if (include) {
        return tagOptions.filter((el) => ids.includes(el.value.toString()))
      } else {
        return tagOptions.filter((el) => !ids.includes(el.value.toString()))
      }
    },
    [tagOptions]
  )

  const findTag = useCallback(
    (id: string) => {
      return tagOptions.find((el) => el.value === id)
    },
    [tagOptions]
  )

  return {
    state: {
      statusOptions,
      tagOptions,
    },
    actions: {
      findStatus,
      findTag,
      findTags,
      setTagOptionFromArr,
    },
  }
}
